import { render, staticRenderFns } from "./revokeTip.vue?vue&type=template&id=d20461fe&scoped=true"
import script from "./revokeTip.vue?vue&type=script&lang=js"
export * from "./revokeTip.vue?vue&type=script&lang=js"
import style0 from "./revokeTip.vue?vue&type=style&index=0&id=d20461fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20461fe",
  null
  
)

export default component.exports